<template>
  <div class="flex flex-col">
    <div class="p-2 rounded-md bg-gray-100">
      <span class="text-gray-300 uppercase">Logs</span>
      <div class="flex flex-col p-2 text-sm max-h-40 overflow-y-auto rounded-md bg-white">
        <span
          v-for="log in logs"
          :key="log">
          {{ log }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    logs: undefined,
  }
}
</script>
